import { render, staticRenderFns } from "./answerStat.vue?vue&type=template&id=b01d2e12&scoped=true&"
import script from "./answerStat.vue?vue&type=script&lang=js&"
export * from "./answerStat.vue?vue&type=script&lang=js&"
import style0 from "./answerStat.vue?vue&type=style&index=0&id=b01d2e12&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01d2e12",
  null
  
)

export default component.exports